require('./bootstrap');
import 'jsgrid/dist/jsgrid.js';
import 'jquery-ui/ui/widgets/dialog.js';
import 'jquery-ui/ui/widgets/tabs.js';
import 'jquery-ui/ui/widgets/sortable.js';
import 'jquery-validation/dist/jquery.validate.js';
import 'select2/dist/js/select2';
import 'orgchart/dist/js/jquery.orgchart';
import 'html2canvas/dist/html2canvas';
import 'jspdf/dist/jspdf.es';
import 'bootstrap4-toggle/js/bootstrap4-toggle.min';
import 'jquery.flipster/dist/jquery.flipster.min';
import 'canvasjs/dist/jquery.canvasjs.min';
import 'imask/dist/imask.js';
import './nav.js';
import 'jquery-raty-js/lib/jquery.raty';
import 'cubeportfolio/src/js/jquery.cubeportfolio.js';
import 'jquery.appear/jquery.appear.js';
require('leaflet');
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import WOW from 'wow.js/dist/wow.js';
window.WOW = WOW;

